import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLanguage } from "@/LanguageContext";
import { Asterisk, EASE } from "@/components/Reveal";

const copy = {
  it: {
    text: "Questo sito utilizza solo cookie tecnici, necessari al corretto funzionamento della navigazione. Nessun tracciamento di marketing.",
    accept: "Ok, capito",
    more: "Privacy Policy",
  },
  en: {
    text: "This site only uses technical cookies, strictly necessary for browsing. No marketing tracking.",
    accept: "Got it",
    more: "Privacy Policy",
  },
};

const CookieBanner = () => {
  const { lang } = useLanguage();
  const [visible, setVisible] = useState(false);
  const c = copy[lang] || copy.it;

  useEffect(() => {
    if (!localStorage.getItem("noom-cookie-ok")) {
      const timer = setTimeout(() => setVisible(true), 1800);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("noom-cookie-ok", "1");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.6, ease: EASE }}
          className="fixed bottom-4 left-4 right-4 z-[95] sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-md"
        >
          <div className="border border-noom-line bg-white p-6">
            <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-noom-lilacDeep">
              <Asterisk className="h-3 w-3 text-noom-lilac" />
              Cookie
            </p>
            <p className="mt-3 text-sm leading-relaxed text-noom-muted">{c.text}</p>
            <div className="mt-5 flex items-center gap-5">
              <button
                data-testid="cookie-accept-button"
                onClick={accept}
                className="rounded-full bg-noom-ink px-5 py-2.5 text-xs font-semibold text-white transition-colors duration-300 hover:bg-noom-lilac hover:text-noom-ink"
              >
                {c.accept}
              </button>
              <Link
                data-testid="cookie-privacy-link"
                to="/privacy"
                className="font-mono text-[11px] uppercase tracking-[0.14em] text-noom-faint underline-offset-4 transition-colors duration-300 hover:text-noom-ink hover:underline"
              >
                {c.more}
              </Link>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
